export default "__VITE_ASSET__6e5cb95d__"